import PropTypes from "prop-types";
import SegmentedControl from "shared/components/inputs/segmented-control/SegmentedControl";
import FormInputWrapper from "../form/FormInputWrapper";
import { useFormInput } from "./utils";

const SegmentControlFormElement = ({
    name,
    validations,
    label,
    description,
    helpText,
    className,
    isSmallSize,
    ...rest
}) => {
    const { wrapperProps, inputProps } = useFormInput({
        name,
        validations,
        isControlled: true,
    });

    return (
        <FormInputWrapper
            {...{ label, description, helpText, className, isSmallSize }}
            {...wrapperProps}
        >
            <SegmentedControl
                {...rest}
                {...inputProps}
                ref={undefined}
                segmentedButtonType="button"
            />
        </FormInputWrapper>
    );
};

SegmentControlFormElement.propTypes = {
    name: PropTypes.string.isRequired,
    validations: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    helpText: PropTypes.string,
    className: PropTypes.string,
    isSmallSize: PropTypes.bool,
};

export default SegmentControlFormElement;
